module.exports = __webpack_public_path__ + "static/img/13.bb239f4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/2/1/zh/13.png
// module id = uku4
// module chunks = 0